import Vue from 'vue'
import App from './App.vue'
import router from './router'
import vuetify from './plugins/vuetify'
import VueApexCharts from 'vue-apexcharts'

Vue.use(VueApexCharts)
Vue.component('apexchart', VueApexCharts)


import { PublicClientApplication, LogLevel } from '@azure/msal-browser'

import dayjs from 'dayjs'
import 'dayjs/locale/th'
import buddhistEra from 'dayjs/plugin/buddhistEra'
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter'
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore'
Vue.prototype.$dayjs = dayjs
dayjs.extend(isSameOrAfter)
dayjs.extend(isSameOrBefore)
dayjs.extend(buddhistEra)
dayjs.locale('th')


Vue.config.productionTip = false


const msalConfig = {
  auth: {
    clientId: 'cd589853-e246-4124-a2cc-3b3bb299db78',
    authority: 'https://login.microsoftonline.com/5a8c21e3-7c52-40e3-8d81-deba37efd8dc',
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin + '/login',
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: 'localStorage',
    storeAuthStateInCookie: false,
  },
  system: {
    allowNativeBroker: false,
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return
        switch (level) {
          case LogLevel.Error:
            console.error('[MSAL]', message)
            break
          case LogLevel.Warning:
            console.warn('[MSAL]', message)
            break
          case LogLevel.Info:
            console.info('[MSAL]', message)
            break
          case LogLevel.Verbose:
            console.debug('[MSAL]', message)
            break
        }
      },
      logLevel: LogLevel.Info,
      piiLoggingEnabled: false,
    },
  },
}

// ---------- STATE ----------
let appInstance = null
const msalInstance = new PublicClientApplication(msalConfig)

// ---------- UTILS ----------
function storeAuthToken(token) {
  if (token) localStorage.setItem('isToken', token)
}

function clearAuthToken() {
  localStorage.removeItem('isToken')
}

function mountApp() {
  if (!Vue.prototype.$msal) Vue.prototype.$msal = msalInstance

  if (!appInstance) {
    appInstance = new Vue({
      router,
      vuetify,
      render: h => h(App),
    }).$mount('#app')
  }
}


// ---------- CHECK EXISTING AUTH ----------
async function checkExistingAuth() {
  try {
    // Initialize MSAL
    if (typeof msalInstance.initialize === 'function') {
      await msalInstance.initialize()
    }

    // Process redirect promise (handles return from MSAL redirects or popups)
    const redirectResponse = await msalInstance.handleRedirectPromise()
    if (redirectResponse && redirectResponse.account) {
      console.log('🔐 Login: MSAL (redirect response)')
      msalInstance.setActiveAccount(redirectResponse.account)
      storeAuthToken(redirectResponse.idToken || redirectResponse.accessToken)
      localStorage.setItem('isAuthenType', 'MSAL')
      return true
    }

    // ตรวจสอบ MSAL accounts ที่มีอยู่
    const accounts = msalInstance.getAllAccounts()
    if (accounts.length > 0) {
      // console.log('[MSAL] Found existing account')
      msalInstance.setActiveAccount(accounts[0])

      try {
        const tokenResponse = await msalInstance.acquireTokenSilent({
          account: accounts[0],
          scopes: ['User.Read', 'api://cd589853-e246-4124-a2cc-3b3bb299db78/instructor-prod'],
        })

        if (tokenResponse) {
          // console.log('[MSAL] Token acquired silently')
          storeAuthToken(tokenResponse.idToken || tokenResponse.accessToken)
          return true
        }
      } catch (silentError) {
        // Silent token acquisition failed
      }
    }

    return false
  } catch (err) {
    console.error('Check existing auth error:', err)
    return false
  }
}

// ---------- LOGOUT ----------
function logoutAll() {
  localStorage.clear()
  sessionStorage.clear()


  const account = msalInstance.getActiveAccount()
  if (account) {
    msalInstance.logoutRedirect({
      account,
      postLogoutRedirectUri: window.location.origin + '/login',
    })
    return
  }

  router.replace({ name: 'Login' })
}

Vue.prototype.$logoutAll = logoutAll

  // ---------- APP BOOTSTRAP ----------
  ; (async function bootstrapAuthentication() {
    try {
      sessionStorage.removeItem('msal.interaction.status')

      const isAuthenticated = await checkExistingAuth()

      localStorage.setItem('isAuthenticated', isAuthenticated ? 'true' : 'false')
      if (!isAuthenticated) clearAuthToken()

      mountApp()

      const currentRoute = router.currentRoute
      if (isAuthenticated) {
        const redirectRoute = currentRoute.query.redirect || { name: 'Dashboard' }
        router.replace(redirectRoute)
      } else if (currentRoute.matched.some(r => r.meta?.requiresAuth)) {
        router.replace({ name: 'Login', query: { redirect: currentRoute.fullPath } })
      }
    } catch (err) {

      console.error('Bootstrap error:', err)
      sessionStorage.removeItem('msal.interaction.status')
      clearAuthToken()
      localStorage.setItem('isAuthenticated', 'false')
      mountApp()

      const currentRoute = router.currentRoute
      if (currentRoute.matched.some(r => r.meta?.requiresAuth)) {
        router.replace({ name: 'Login', query: { redirect: currentRoute.fullPath } })
      }

    }
  })()